export const zuiOrange = {
  100: '#FDE5D3',
  200: '#FAC7A3',
  300: '#F8AA72',
  400: '#F58D42',
  500: '#F36F12',
  600: '#C7590A',
  700: '#964308',
  main: '#F36F12',
};
